import { useState } from 'react';
import { Selection } from '@quero-delivery/quero-components-web';
import Tooltip from 'rc-tooltip';
import { usePutChangePlaceLinked } from '../../api/put-change-place-linked';

import styles from './toogle-linked.module.scss';
import { ConfirmationModal } from '@/_components/confirmation-modal';

interface ToogleLinkedProps {
  placeId: string;
  isLinked: boolean;
}

function ToggleLinked({ placeId, isLinked }: ToogleLinkedProps) {
  const [isPlaceLinked, setIsPlaceLinked] = useState(isLinked);
  const [isOpenConfirmationModal, setIsOpenConfirmationModal] = useState(false);

  function handleCloseConfirmationModal() {
    setIsOpenConfirmationModal(false);
  }

  const { mutate: putChangePlaceLinked, isLoading } = usePutChangePlaceLinked({
    onSuccess: () => {
      setIsPlaceLinked(prev => !prev);
      handleCloseConfirmationModal();
    },
  });

  return (
    <div>
      <Tooltip
        overlay={
          <b>
            Ao habilitar a gestão própria, somente os entregadores próprios
            serão chamados.
          </b>
        }
        placement="top"
        mouseEnterDelay={0.5}
        overlayClassName="white-tooltip"
      >
        <div className={styles.toggleOnlyDedicate}>
          <Selection
            type="switch"
            checked={isPlaceLinked}
            disabled={isPlaceLinked}
            onClick={() => setIsOpenConfirmationModal(true)}
            className="switch-with-colors"
          />
          <b>Gestão Própria</b>
        </div>
      </Tooltip>
      <ConfirmationModal
        open={isOpenConfirmationModal}
        onClose={handleCloseConfirmationModal}
        handleConfirm={() =>
          putChangePlaceLinked({
            placeId,
            isLinked: !isPlaceLinked,
          })
        }
        isLoading={isLoading}
        questionText={
          <>
            Você tem certeza que deseja{' '}
            {isPlaceLinked ? 'desabilitar' : 'habilitar'} a{' '}
            <b>gestão própria</b> para este estabelecimento?
          </>
        }
        title={`${isPlaceLinked ? 'Desabilitar' : 'Habilitar'} gestão própria`}
      />
    </div>
  );
}

export { ToggleLinked };
